import {
  requestGlobeLoader,
  releaseGlobeLoader,
} from "./globalLoaderController";

export const SHOW_LOADER = "SHOW_LOADER";
export const HIDE_LOADER = "HIDE_LOADER";
export const SHOW_BLOCKING_OVERLAY = "SHOW_BLOCKING_OVERLAY";
export const HIDE_BLOCKING_OVERLAY = "HIDE_BLOCKING_OVERLAY";

/** Starts invisible click shield; shows globe only if loading exceeds the threshold. */
export function showLoader(): void {
  requestGlobeLoader();
}

/** Ends loading and hides the click shield or globe as appropriate. */
export function hideLoader(): void {
  releaseGlobeLoader();
}

export { resetGlobeLoader } from "./globalLoaderController";
